<template>
  <div id="menu-alert-section" class="outer alert-sticky-wrapper">
    <content-container>
      <a v-if="url" :href="url" class="inner row">
        <div v-if="title" class="title">{{ title }}</div>
        <div class="copy-wrapper">
          <div v-if="copy" class="copy">{{ copy }}</div>
          <div class="banner-icon-wrapper">
            <icon-base width="10px" height="10px" :iconName="'Click to visit link'">
              <icon-arrow-right />
            </icon-base>
          </div>
        </div>
      </a>
      <div v-else class="inner row">
        <div v-if="title" class="title">{{ title }}</div>
        <div v-if="copy" class="copy">{{ copy }}</div>
      </div>
    </content-container>
  </div>
</template>

<script>
import ContentContainer from './ContentContainer.vue'
import IconBase from './IconBase.vue'
import IconArrowRight from './icons/IconArrowRight.vue'

export default {
  name: 'PageBanner',
  components: {
    ContentContainer,
    IconBase,
    IconArrowRight,
  },
  props: {
    title: {
      type: String,
    },
    copy: {
      type: String,
    },
    url: {
      type: String,
    },
  },
  mounted() {
    var tabsSection = document.getElementById('menu-tabs-section')
    var alertSection = document.getElementById('menu-alert-section')
    if (tabsSection) {
      tabsSection.style.top = alertSection.offsetHeight + 'px'
    }
  },
}
</script>

<style scoped lang="scss">
.outer {
  padding: 12px 0;
}

.inner {
  // display: flex;
  // flex-wrap: wrap;
  // align-items: center;

  width: 100%;
  text-decoration: none;
  font-size: 18px;
  text-align: center;
}

.title,
.copy {
  display: inline-block;
  vertical-align: middle;
  color: $white;
}

.title {
  color: $gold;
  font-size: 2.3rem;
  font-weight: 900;
  margin-right: 20px;
}

.copy-wrapper {
  display: flex;
  align-items: ceil($number: 0);
}

.banner-icon-wrapper {
  @include transition(transform);
  flex: 0 0 auto;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: $white;
  color: $black;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;

  .inner:hover &,
  .inner:focus & {
    transform: translate(5px, 0);
  }
}

.alert-sticky-wrapper {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: $tomato;
  max-height: 90px;
  overflow: auto;
}
</style>
